import {Pill} from '@wandb/components';
import React, {useContext} from 'react';
import {Link} from 'react-router-dom';

import {useArtifactCollectionOverviewQuery} from '../../generated/graphql';
import * as Urls from '../../util/urls';
import {
  checkRegistryProject,
  resolveRegistryUrl,
} from '../Registries/common/utils';
import {AccountSelectorContext} from '../Search/SearchNav/AccountSelectorContextProvider';

export const ArtifactCollectionPill = ({
  collectionId,
}: {
  collectionId: string;
}) => {
  const {selectedAccount} = useContext(AccountSelectorContext);
  const {data} = useArtifactCollectionOverviewQuery({
    variables: {artifactCollectionID: collectionId, includeOverview: false},
  });
  const collection = data?.artifactCollection;
  const entityName = collection?.project?.entityName;
  const projectName = collection?.project?.name;
  const artifactTypeName = collection?.defaultArtifactType?.name;
  const collectionName = collection?.name;
  let href: string | null = null;

  if (entityName && projectName && collectionName) {
    if (collection?.__typename === 'ArtifactPortfolio') {
      const {isRegistryProject, registryName} =
        checkRegistryProject(projectName);
      href = resolveRegistryUrl(
        isRegistryProject,
        selectedAccount?.name ?? entityName,
        registryName ?? 'model',
        {entityName, projectName, collectionName},
        entityName,
        'versions',
        undefined,
        'overview'
      );
    } else if (artifactTypeName) {
      href = Urls.artifactSequence({
        entityName,
        projectName,
        artifactTypeName,
        artifactSequenceName: collectionName,
      });
    }
  }

  const pill = (
    <Pill
      icon="database-artifacts"
      textValue={collectionName ?? collectionId}
    />
  );

  return href == null ? (
    pill
  ) : (
    <Link
      to={href}
      title="Open the artifact collection"
      className="inline-flex no-underline">
      {pill}
    </Link>
  );
};
